import { render, staticRenderFns } from "./LogosStep.vue?vue&type=template&id=38009064&scoped=true"
import script from "./LogosStep.vue?vue&type=script&lang=js"
export * from "./LogosStep.vue?vue&type=script&lang=js"
import style0 from "./LogosStep.vue?vue&type=style&index=0&id=38009064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38009064",
  null
  
)

export default component.exports